import React, { useEffect, useState } from "react";
import classNames from "classnames";
import ShopInitialBadge from "./ShopInitialBadge";

/** Rounds signature `logo_url` when present; otherwise pastel initials (same as list rows). */
export default function ShopSwitcherLogoOrInitials({
    name,
    colorKey,
    logoUrl,
    variant = "list",
}: {
    name: string;
    colorKey: string;
    logoUrl?: string | null;
    variant?: "list" | "trigger";
}) {
    const [failed, setFailed] = useState(false);
    const trimmed =
        typeof logoUrl === "string" && logoUrl.trim() !== "" ? logoUrl.trim() : "";

    useEffect(() => {
        setFailed(false);
    }, [trimmed]);

    const showImg = Boolean(trimmed) && !failed;

    if (showImg) {
        return (
            <span
                className={classNames(
                    "ew-shop-switcher__logo-wrap",
                    variant === "trigger" && "ew-shop-switcher__logo-wrap--trigger"
                )}
            >
                <img
                    src={trimmed}
                    alt=""
                    className={classNames(
                        "ew-shop-switcher__logo",
                        variant === "trigger" && "ew-shop-switcher__logo--trigger"
                    )}
                    onError={() => setFailed(true)}
                />
            </span>
        );
    }

    return (
        <ShopInitialBadge
            name={name}
            colorKey={colorKey}
            className={variant === "trigger" ? "ew-shop-switcher__initials--trigger" : undefined}
        />
    );
}
